import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./Detailing&coating.css";
import NavComplete from "./Component/Navbar1";
import Footer from "./Component/footer";

const BuyAndSellUsedCar = () => {
  const metaData = {
    name: "description",
    content: "Jual Beli Mobil Bekas information page",
  };
  return (
    <>
      <NavComplete />
      <section className="welcome-section" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', backgroundColor: '#1a1a1a' }}>
        <Container>
          <Row>
            <Col className="container-1">
              <div className="welcome-content" style={{ marginTop: '100px', textAlign: 'left' }}>
                <h1 className="blurry-text" style={{ color: 'white', fontWeight: 'bold' }}>
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Buy and sell Used Car"
                    : "Jual Beli Mobil Bekas"}
                </h1>
                <p className="blurry-text" style={{ color: '#ccc', fontSize: '1.2rem', marginTop: '20px' }}>
                  {localStorage.getItem("bahasa") === "ing"
                    ? "More detailed information about Buy and sell Used Car will be available soon. Please contact us for further details."
                    : "Informasi lebih detail mengenai Jual Beli Mobil Bekas akan segera tersedia. Silakan hubungi kami untuk informasi lebih lanjut."}
                </p>
                                <Button
                  variant="none"
                  style={{ backgroundColor: "#25D366", color: "white", marginTop: '20px' }}
                  href="https://api.whatsapp.com/send?phone=+6281399333280&text=Hallo%20saya%20tertarik%20untuk%20mengetahui%20informasi%20layanan%20Anda"
                  target="_blank"
                >
                  {localStorage.getItem("bahasa") === "ing"
                    ? "Contact via WhatsApp"
                    : "Hubungi via WhatsApp"}
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <div className="section-wraper" style={{ padding: '60px 0', backgroundColor: '#000', color: 'white' }}>
        <Container>
            <h2 className="roleway" style={{ textAlign: 'center', marginBottom: '40px' }}>
                {localStorage.getItem("bahasa") === "ing" ? "Why Choose Us?" : "Mengapa Memilih Kami?"}
            </h2>
            <p className="nunito" style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto', color: '#999' }}>
                {localStorage.getItem("bahasa") === "ing"
                ? "We provide professional and high-quality services ensuring your satisfaction and vehicle's optimal condition."
                : "Kami menyediakan layanan profesional dan berkualitas tinggi yang memastikan kepuasan Anda dan kondisi optimal kendaraan Anda."}
            </p>
        </Container>
      </div>
      <Footer />

      <Helmet>
        <meta name={metaData.name} content={metaData.content} />
      </Helmet>
    </>
  );
};

export default BuyAndSellUsedCar;
